import { render, staticRenderFns } from "./WhsExL_Export.vue?vue&type=template&id=0bfefa8b"
import script from "./WhsExL_Export.vue?vue&type=script&lang=js"
export * from "./WhsExL_Export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports